<template>
  <div>
    <el-table :data="userList" height="calc(100vh - 353px)">
      <el-table-column
        prop="userId"
        label="用户ID"
        align="center"
        fixed="left"
        min-width="150"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.userId }}</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="fromWalletType"
        label="出钱包类型"
        align="center"
        min-width="150"
      >
        <template slot-scope="scope">
          <span>{{ types[scope.row.fromWalletType] }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="toWalletType"
        label="入钱包类型"
        align="center"
        min-width="150"
      >
        <template slot-scope="scope">
          {{ types[scope.row.toWalletType] }}
        </template>
      </el-table-column>
      <el-table-column prop="coin" label="币种" align="center" min-width="140">
        <template slot-scope="scope">
          {{ scope.row.coin }}
        </template>
      </el-table-column>

      <el-table-column
        prop="amount"
        label="金额"
        align="center"
        min-width="160"
      >
        <template slot-scope="scope">
          {{ scope.row.amount }}
        </template>
      </el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        align="center"
        min-width="160"
      >
        <template slot-scope="scope">
          {{ statusText[scope.row.status] }}
        </template>
      </el-table-column>

      <el-table-column label="创建时间" width="150">
        <template slot-scope="scope">{{
          scope.row.createdTime | moment
        }}</template>
      </el-table-column>
    </el-table>
    <div class="pag">
      <pagination
        :size="pagination.size"
        :total="totalCount"
        :page="pagination.page"
        @pageChanged="pageChanged"
      ></pagination>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'
import Pagination from 'components/pagination'
import { STATUSTEXT, TYPES } from '../../constants'

export default {
  name: 'TransferRecordList',
  data() {
    return {
      updateForm: {},
      updateUserTypeDialogVisible: false,
      newUserType: '',
      selectedForUserType: {},
      centerDialogVisible: false,
      textarea2: '',
      type: '',
      id: '',
      statusText: STATUSTEXT,
      types: TYPES,
    }
  },
  components: {
    Pagination,
  },
  methods: {
    pageChanged(pagination) {
      this.$emit('refresh', pagination)
    },
  },
  computed: {
    // ...mapGetters('user', ['userList']),
    ...mapState(['userInfo']),
    ...mapState('transferRecord', ['pagination', 'userList', 'totalCount']),
  },
}
</script>

<style lang="less" src="../../../../../styles/table.less" scoped>
// .pag{
//   display: flex;
//   justify-content: center;
// }
// .user-type-select {
//   width: 100%;
// }
// .red {
//   color: skyblue;
//   font-weight: bold;
// }
// .cc {
//   color: #97a0ff;
//   font-weight: bold;
// }
// ::v-deep .el-dialog__title {
//   color: #6767b3;
//   font-size: 24px;
// }
// ::v-deep.el-dialog__headerbtn {
//   font-size: 26px;
// }
// ::v-deep .el-dialog__body {
//   display: flex;
//   justify-content: center;
//   .main {
//     width: 100%;
//     position: relative;
//     .box-card {
//       width: 100%;
//       height: 260px;
//       .el-card__body {
//         height: 86%;
//         display: flex;
//         flex-direction: column;
//         justify-content: space-between;
//         .el-textarea{
//           box-shadow: 0px 0px 1px rgba(24, 26, 32, 0.1), 0px 3px 6px rgba(71, 77, 87, 0.04), 0px 1px 2px rgba(24, 26, 32, 0.04);
//         }
//         .el-textarea__inner{
//           padding: 18px 16px;
//         }
//         .btn{
//           display: flex;
//           justify-content: center;
//            .el-button--primary{
//       width: 156px;
//       height: 37px;
//       background: #707AFF;
//       border-radius: 4px;
//     }
//         }
//       }
//     }
//   }
// }
// ::v-deep .el-dialog--center {
//   margin-top: 5vh;
//   width: 468px;
//   // height: 557px;
//   background: #f5f6ff;
//   border-radius: 8px;
// }
::v-deep.el-table th {
  font-weight: bold;
  color: #909399;
}
</style>
